<mat-card class="mat-card--widget">
  <mat-card-content class="order-card">
    <div class="row">
      <div class="col s12 m4">
        <img
          class="frame__image"
          [src]="order.lineItems[0].frame.largeImageUrl"
          onError="this.src='/assets/images/frame-default-lg.png'"
        />
      </div>
      <div class="col s12 m4">
        <h2 style="text-align:left; margin-bottom: 10px;">
          {{ order.lineItems[0].patientName }}
        </h2>
        <ng-container *ngIf="interumOrderRow(order); else notInterumOrderRow">
          <div>
            Complete Job
          </div>
        </ng-container>
        <ng-template #notInterumOrderRow>
          <div>
            {{ checkLineUseType(order) }}
          </div>
        </ng-template>
        <div class="mt-5" *ngIf="order.lineItems[0].rxId">Rx ID Entered: {{ order.lineItems[0].rxId }}</div>
        <div class="mt-5">
          {{ order.dropship.name }}
        </div>
        <hr class="divider mt-20" />
        <div class="text-bold">{{ order.lineItems[0].frame.brandName }} {{ order.lineItems[0].frame.styleName }}</div>
        <div class="mt-5">UPC: {{ checkAvailability(order.lineItems[0].frame.upc) }}</div>
        <div class="mt-5">Color: {{ checkAvailability(order.lineItems[0].frame.colorDescription) }}</div>
        <div class="mt-5">Size: {{ checkAvailability(order.lineItems[0].frame.eyeSize) }}</div>
      </div>
      <div class="col s12 m4 text-align-right">
        <h2>Order {{ order.orderNumber }}</h2>
        <h3 class="color-primary removeMargin" style="text-align: right;">
          Ordered on: {{ order.orderDate + 'Z' | date: 'short' }}
        </h3>
        <h4 *ngIf="order.orderedBy" class="color-primary removeMargin" style="text-align: right;">
          {{ 'Ordered by ' + order.orderedBy }}
        </h4>
        <!--FOR FRAME-->
        <span class="text-align-right">
          <ng-container *ngIf="interumOrderRow(order); else notInterumForFrame">
            <p
              class="text-align-right text-semibold"
              [ngClass]="{
                removeMargin: true,
                successColor: getFrameStatus(order)
                  ?.status.toLowerCase()
                  .includes('shipped'),
                lightBrandColor: getFrameStatus(order)?.status.substr(0, 7) !== 'Shipped'
              }"
            >
              {{ getFrameStatus(order)?.status }}
            </p>
          </ng-container>
          <ng-template #notInterumForFrame>
            <p
              class="text-align-right text-semibold"
              [ngClass]="{
                removeMargin: true,
                successColor: getFrameStatus(order)?.status.substr(0, 7) == 'Shipped',
                lightBrandColor: getFrameStatus(order)?.status.substr(0, 7) != 'Shipped'
              }"
            >
              {{ getFrameStatus(order)?.status }}
            </p>
          </ng-template>

          <span
            class="status text-align-right text-semibold"
            style="display:inline-block;"
            *ngIf="getFrameStatus(order)?.detail !== ''"
          >
            <div style="cursor:pointer;" class="secondaryColor">
              <!-- v-tooltip.top-center="getFrameStatus(order)?.detail"-->
              <i class="fa fa-info-circle info-tooltip" aria-hidden="true"></i>
            </div>
          </span>
        </span>
        <!--FOR RX-->
        <ng-container *ngIf="interumOrderRow(order); else notInterumRx">
          <span class="text-align-right text-semibold">
            <p class="lightBrandColor removeMargin">
              For Rx order status inquires, please call<br />
              {{ getContactInfo(order) }}
            </p>
          </span>
        </ng-container>

        <ng-template #notInterumRx>
          <h5
            [ngClass]="{
              removeMargin: true,
              successColor: getRxStatus(order).status.substr(3, 7) == 'shipped',
              lightBrandColor: true
            }"
            class="ng-binding removeMargin lightBrandColor"
            style="display:inline-block"
          >
            {{ getRxStatus(order).status }}
          </h5>

          <span class="status" style="display:inline-block;" v-if="getRxStatus(order).detail != ''">
            <div style="cursor:pointer;" v-tooltip.top-center="getRxStatus(order).detail">
              <i class="fa fa-info-circle info-tooltip" aria-hidden="true"></i>
            </div>
          </span>
        </ng-template>
        <!--        <ng-container *ngIf="interumOrderRow(order)">-->
        <h3
          class="primaryColor removeMargin text-align-right"
          *ngIf="order.trackingNumber !== null && order.trackingNumber !== '' && order.trackingNumber !== undefined"
        >
          Tracking No:
          <a
            mat-button
            class="btn btn-primary"
            target="_blank"
            href="https://www.ups.com/track?loc=en_US&tracknum={{ order.trackingNumber }}"
            >{{ order.trackingNumber }}</a
          >
        </h3>
        <!--        </ng-container>-->

        <h3 *ngIf="order.slaFlag === true" class="errorColor removeMargin">
          Please contact Frame Dream customer service via phone (855-658-1705) about this job. Please be aware we can't
          process the job until we speak to you.
        </h3>
      </div>
    </div>
  </mat-card-content>
</mat-card>
